import React, { Component } from 'react';
import { numberFormatter } from 'utils/formatter';
import styles from './TenorTable.css';

class TableInputItem extends Component {
  state = {
    value: '',
    errors: {},
  };

  onChange = e => {
    const { onValueChange } = this.props;
    this.setState({ value: e.target.value });
    onValueChange(parseInt(e.target.value));
    this.validateValue(e.target.value);
  };

  onBlur = e => {
    const { data, onValueChange } = this.props;
    const miniumLoan = data.minimum_loan / 1000000;
    const maximumLoan = data.pre_approved_amount / 1000000;
    let setValue = parseInt(e.target.value);
    if (setValue < miniumLoan) {
      setValue = miniumLoan;
    }
    if (setValue > maximumLoan) {
      setValue = maximumLoan;
    }
    if (setValue > 200) {
      setValue = 200;
    }
    this.setState({ value: setValue });
    this.setState({ errors: {} });
    onValueChange(setValue);
  };

  interest = loan => {
    let result = 0;
    if (loan > 9 && loan < 51) result = 1.49;
    if (loan > 50 && loan < 100) result = 1.39;
    if (loan > 99 && loan < 201) result = 1.19;
    return result;
  };

  repayments = (loan, tenor) => {
    let result = 0;
    if (loan > 200 || loan < 10) {
      result = 0;
    } else {
      result =
        (loan * 1000000 * (1 + (tenor * this.interest(loan)) / 100)) / tenor;
    }
    return numberFormatter(result);
  };

  validateValue = loan => {
    const { data } = this.props;
    const error = {};

    if (loan !== '') {
      if (loan !== 0 && loan < 10) {
        error.value = 'Minimum pinjaman adalah Rp10 juta';
      }
      if (loan > 200) {
        error.value = 'Maksimum pinjaman adalah Rp200 juta';
      }
      if (loan > data.pre_approved_amount / 1000000) {
        error.value = `Limit pinjaman adalah Rp${data.pre_approved_amount /
          1000000} juta`;
      }
    }

    this.setState({ errors: error });
  };

  onClickEvent = () => {
    const { data, onClick } = this.props;
    if (data.pre_approved_amount === 0) {
      return;
    }
    onClick();
  };

  render() {
    const { value, errors } = this.state;
    const { data, activeIndex } = this.props;

    return (
      <div
        className={
          styles[
            `${
              data.pre_approved_amount !== 0
                ? 'input-item-wrapper'
                : 'input-item-wrapper-disabled'
            }`
          ]
        }
        onClick={this.onClickEvent}
      >
        <div className={styles['options-wrapper']}>
          <div className={styles.options}>
            {activeIndex === data.index && <div className={styles.active} />}
          </div>
          <p className={styles['text-body']}>{data.duration_label}</p>
        </div>
        <div className={styles.line} />
        <div className={styles['max-amount']}>
          <p className={styles['text-body']}>
            {numberFormatter(data.pre_approved_amount)}
          </p>
        </div>
        <div className={styles.line} />
        <div className={styles['input-content']}>
          {errors.value !== undefined && (
            <div className={styles['info-wrapper']}>
              <div className={styles['info-wrong-value']}>
                <p className={styles['info-desc']}>{errors.value}</p>
              </div>
            </div>
          )}
          <div
            className={
              styles[
                `${
                  data.pre_approved_amount !== 0
                    ? 'input-content-border'
                    : 'input-content-border-disabled'
                }`
              ]
            }
          >
            <div className={styles.currency}>
              <p className={styles['text-body']}>Rp</p>
            </div>
            <div className={styles['input-wrapper']}>
              <input
                className={styles.input}
                placeholder={0}
                value={value}
                onChange={this.onChange}
                onBlur={this.onBlur}
                disabled={data.pre_approved_amount === 0}
                type="number"
              />
              <p className={styles['text-body']}>Juta</p>
            </div>
          </div>
        </div>
        <div className={styles.line} />
        <p className={styles['text-body']}>
          {this.interest(parseInt(value))} %
        </p>
        <div className={styles.line} />
        <p className={styles['text-body']}>
          {this.repayments(parseInt(value), data.duration)}
        </p>
      </div>
    );
  }
}

export default TableInputItem;
